import React from 'react';
import { Modal } from 'app/components';

const DeleteModal = ({ onCancel, onConfirm, isOpen, ticketName }) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        size={'regular'}
        primaryText="Delete"
        secondaryText="Cancel"
        children=<div className="heading-24">
          Are you sure you want to delete{' '}
          <span className="text-error">{ticketName}</span> from the list?
        </div>
        onClickPrimaryCta={onConfirm}
        onClickSecondaryCta={onCancel}
        className='delete-modal'
      />
    </div>
  );
};

export default DeleteModal;
